import Api from  "@/services/AxiosAPI";

export default {
  
  getquickguidesmenu() {
    return Api.getData('quick-guide-left-menu')
      .then(responses => {
        return responses
      });

  },
  getheadermenu() {
    return Api.getData('header-menu')
      .then(responses => {
        return responses
      });

  }
}